module.exports = __webpack_public_path__ + "static/media/health-and-disease-anxiety@3x.0453fea5.png";